import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { usePromptFragment, useUpdatePromptFragment } from "../hooks";
import { PromptFragmentForm } from "../components";

type IUpdatePromptFragment = {
  id: string;
};

export const UpdatePromptFragment: React.FC = () => {
  const { id } = useParams<IUpdatePromptFragment>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = usePromptFragment(+id!);
  const { form, submit, loading } = useUpdatePromptFragment({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le fragment a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.promptFragment?.ok && data?.promptFragment?.result) {
      const { result } = data.promptFragment;
      form.setValue("code", result.code);
      form.setValue("name", result.name);
      form.setValue("promptText", result.promptText);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Fragment de prompt"
        subtitle={data?.promptFragment?.result?.name ?? ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/prompt-fragments`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un fragment" />
          <PromptFragmentForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
